export const puapMakes = [
    "Acura",
    "Alfa Romeo",
    "AMC",
    "Aston Martin",
    "Audi",
    "Austin",
    "Austin-Healey",
    "Bentley",
    "BMW",
    "BrightDrop",
    "BYD",
    "Buick",
    "Cadillac",
    "Checker",
    "Chevrolet",
    "Chrysler",
    "Coda",
    "Cruise",
    "Daewoo",
    "Daihatsu",
    "Datsun",
    "DeLorean",
    "Dodge",
    "Eagle",
    "Ferrari",
    "Fiat",
    "Fisker",
    "Ford",
    "Freightliner",
    "Genesis",
    "Geo",
    "GMC",
    "Honda",
    "Hummer",
    "Hyundai",
    "Ineos",
    "Infiniti",
    "International",
    "Isuzu",
    "Jaguar",
    "Jeep",
    "Jensen-Healey",
    "Karma",
    "KIA",
    "Lamborghini",
    "Land Rover",
    "Lexus",
    "Lincoln",
    "Lucid",
    "Lotus",
    "Mahindra",
    "Maserati",
    "Maybach",
    "Mazda",
    "McLaren",
    "Mercedes Benz",
    "Mercury",
    "Merkur",
    "MG",
    "Mini",
    "Mitsubishi",
    "Nissan",
    "Oldsmobile",
    "Opel",
    "Peugeot",
    "Plymouth",
    "Polestar",
    "Pontiac",
    "Porsche",
    "RAM",
    "Renault",
    "Rivian",
    "Rolls-Royce",
    "SAAB",
    "Saturn",
    "Scion",
    "Smart",
    "Sterling",
    "Studebaker",
    "Subaru",
    "Suzuki",
    "Tesla",
    "Th!nk",
    "Toyota",
    "Triumph",
    "VinFast",
    "Volkswagen",
    "Volvo",
    "Yugo",
  ];
